import React, { Suspense, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { CompaniesDataList } from '../components/CompaniesDataList';
import { LoadingSpinner } from '../../common/components/LoadingSpinner';
import { ListSearchAndLimit } from '../../common/components/ListSearchAndLimit';
import { PageFrame } from '../../common/components/PageFrame';
import { AddButton } from '../../common/components/AddButton';
import { SearchBar } from '../../common/components/SearchBar';

export const CompaniesListPage = () => {
  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);

  return (
    <PageFrame
      title="Companies"
      topBarContent={
        <>
          <SearchBar placeholder="Search companies" onChange={setQuery} />
          <AddButton text="Add Company" to="/companies/add" />
        </>
      }
    >
      <ListSearchAndLimit
        onSearch={setQuery}
        limit={limit}
        setLimit={setLimit}
      />
      <Suspense fallback={<LoadingSpinner />}>
        <CompaniesDataList offset={offset} limit={limit} query={query} />
      </Suspense>
      <Button
        variant="secondary"
        type="button"
        className="mr-3 border-orange-br bg-orange-br"
        disabled={offset === 0}
        onClick={() => setOffset(offset - limit)}
      >
        Previous
      </Button>
      <Button
        variant="secondary"
        type="button"
        className="border-orange-br bg-orange-br"
        onClick={() => setOffset(offset + limit)}
      >
        Next
      </Button>
    </PageFrame>
  );
};
